export enum SortDirection {
    asc,
    desc
}

export interface ISortableFilter {
    sortColumn: string;
    sortDirection: SortDirection;
    page: number;
    pageSize: number;

    noCache: number; // IE fix
}

export class SortableFilter implements ISortableFilter {
    sortColumn: string;
    sortDirection: SortDirection;
    page: number;
    pageSize: number;

    searchString: string;

    noCache: number; // IE fix

    constructor(sortColumn: string, sortDirection: SortDirection = SortDirection.asc) {
        this.sortColumn = sortColumn;
        this.sortDirection = sortDirection;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/common/sortable-filter.ts